<template>
  <div class="cabinet-login-header">
    <div class="logo">
      <img src="/assets/images/logo_tradeview_full_dark.svg" alt="">
    </div>
    <div class="options">
      <!--      <button @click="contactUsClicked">Contact us</button>-->
      <a href="#" class="links">Contact us</a>
      <div class="pipe">|</div>
      <CustomSelector class="cabinet-login-language" v-model="language" :options="languages"></CustomSelector>
    </div>
  </div>
</template>

<script>
// import i18n from '../../plugins/i18n';

import CustomSelector from "@/components/CustomSelector";

export default {
  name: "LoginHeader",
  components: {
    CustomSelector
  },
  data () {
    return {
      language: 'en',
      languages: [
        {
          text: 'English',
          value: 'en'
        },
        {
          text: 'Español',
          value: 'es'
        },
      ]
    }
  },
  mounted() {
    this.language = this.languages[0].value;
  },
  watch: {
    language () {
      console.log(this.language);
      this.changeLocale(this.language);
    }
  },
  methods: {
    changeLocale (locale) {
      this.$i18n.locale = locale
    },
    contactUsClicked () {
      console.log('contactUsClicked()');
    }
  }
}
</script>
